import React, { useEffect } from 'react';
import { X, ArrowRight } from 'lucide-react';
import CasePanel from './CasePanel';

const CaseSlidePanel = ({ caseId, isOpen, onClose }) => {
  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen || !caseId) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        className="fixed inset-0 bg-gray-900/20 z-40 animate-in fade-in duration-200"
      />

      {/* Slide Panel - Linear style */}
      <div className="fixed top-0 right-0 bottom-0 w-[600px] bg-white border-l border-gray-200 z-50 animate-in slide-in-from-right duration-200 flex flex-col">
        {/* Content */}
        <CasePanel caseId={caseId} onClose={onClose} />

        {/* ESC hint */}
        <div className="absolute bottom-4 left-4 px-2 py-1 bg-gray-900 text-white text-xs rounded flex items-center gap-1.5">
          <kbd className="px-1 py-0.5 bg-white/20 rounded font-mono text-xs">ESC</kbd>
          <span>lukk</span>
        </div>
      </div>
    </>
  );
};

export default CaseSlidePanel;
